import React from "react";
import { appUrl } from "@/lib/referral";

/**
 * Staleness banner — appears only when the entitlements fetch failed and
 * the site is rendering the last-known snapshot instead of live values.
 * Deliberately low-key: this is disclosure, not an alarm. The presence of
 * the banner is the honesty; the design isn't meant to distract.
 */
export const StalenessBanner = ({ lastUpdated, error }) => {
  const when = lastUpdated
    ? new Date(lastUpdated).toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="mb-10 border border-gold/40 bg-gold/[0.06] px-5 py-4 flex items-start gap-3"
      data-testid="entitlements-staleness-banner"
    >
      <span
        className="mt-[6px] block w-1.5 h-1.5 rounded-full bg-gold flex-shrink-0"
        aria-hidden="true"
      />
      <p
        className="font-body italic text-sm text-nearblack/80 leading-relaxed"
        data-testid="entitlements-staleness-copy"
      >
        Prices shown reflect our last-known values{when ? ` (${when})` : ""} —
        our live sync with the app is momentarily unavailable. Sign in at{" "}
        <a
          href={appUrl("https://work.voxiumscript.com")}
          className="underline decoration-gold/60 underline-offset-2 hover:text-gold-600"
        >
          work.voxiumscript.com
        </a>{" "}
        for the current catalog and caps.
        {error ? (
          <span className="sr-only" data-testid="entitlements-staleness-error">
            {error}
          </span>
        ) : null}
      </p>
    </div>
  );
};

export default StalenessBanner;
